export const addFavorite = /* GraphQL */ `
  mutation CreateResourceFavorite($input: CreateResourceFavoriteInput!) {
    createResourceFavorite(input: $input) {
      id
      sk
      createdAt
      updatedAt
    }
  }
`;

export const removeFavorite = /* GraphQL */ `
  mutation DeleteResourceFavorite($input: DeleteResourceFavoriteInput!) {
    deleteResourceFavorite(input: $input) {
      id
      sk
      createdAt
      updatedAt
    }
  }
`;
